import React from "react"
import CCMFollowUpView from "../components/CCMAdmin/CCMFollowUp/CCMFollowUpView"

const CCMFollowUp = () => <CCMFollowUpView />

export default CCMFollowUp
